module.exports = __webpack_public_path__ + "static/media/po-undercarriage-8.35c89dbe.png";